// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__fWNkY","cell":"ColumnAccessor_cell__2UPA-","firstCellAccent":"ColumnAccessor_firstCellAccent__3zcPR"};